module.exports = __webpack_public_path__ + "media/images/company_logo/logo_bencom-932ecd9e9ecafa868d8d84cb9ce940cb.jpg";